import { createIcon } from './create-icon'

export const Play = createIcon({
  displayName: 'Play',
  paths: [
    'M170.667 768c0 29.568 15.317 57.045 40.491 72.576 13.696 8.491 29.227 12.757 44.843 12.757 13.056 0 26.112-2.987 38.187-9.003l512-256c28.885-14.464 47.147-44.032 47.147-76.331s-18.261-61.867-47.147-76.331l-512-256c-12.075-6.016-25.131-9.003-38.187-9.003-15.616 0-31.147 4.267-44.843 12.757-25.173 15.531-40.491 43.008-40.491 72.576v512z'
  ]
})
